import * as React from 'react';
import styles from './global-loader.module.styl';
export const GlobalLoader = () => <div className={styles.globalLoading} data-sentry-component="GlobalLoader" data-sentry-source-file="global-loader.tsx" />;